import axios from 'axios';
const baseURL = `${process.env.REACT_APP_CR_API}`;
const key = `?key=${process.env.REACT_APP_CR_API_KEY}`;

export const getRaiderById = ( id ) => {
    return axios.get(`${baseURL}/raider/${id}${key}`);
}